<template>
  <v-dialog persistent v-model="createEnrolledOrganization" width="700">
    <v-card class="min-height">
      <v-card-title class="headline grey lighten-2"
        >Create New Organization Campaign</v-card-title
      >
      <v-card-text>
        <CCol sm="12" class="p-0">
          <v-form ref="createForm" v-model="valid">
            <v-row class="my-0">
              <v-col md="6">
                <label for>Name of organization *</label>
                <v-text-field
                  name="Name"
                  placeholder="Name"
                  outlined
                  hide-details="auto"
                  v-model="organization.name"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <label for>Contact Person *</label>
                <v-text-field
                  name="Name"
                  placeholder="Name"
                  outlined
                  hide-details="auto"
                  v-model="organization.contact.name"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col md="6">
                <label for>Contact Number *</label>
                <v-text-field
                  name="Number"
                  placeholder="Number"
                  outlined
                  hide-details="auto"
                  v-model="organization.contact.mobile"
                  :rules="mobileRules"
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <label for>Email *</label>
                <v-text-field
                  name="Email"
                  placeholder="Email"
                  outlined
                  hide-details="auto"
                  v-model="organization.contact.email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col md="6">
                <label for>Campaign Name *</label>
                <v-text-field
                  name="Campaign Name"
                  placeholder="Campaign Name"
                  outlined
                  hide-details="auto"
                  v-model="campaignName"
                  :rules="campaignNameRules"
                ></v-text-field>
              </v-col>

              <v-col md="6">
                <label for class="col-sm-12 p-0">Date Range *</label>
                <datepicker
                  v-model="dateRange"
                  @input="onDateChange"
                  ref="datepicker"
                  :min-date="new Date()"
                  is-range
                  :masks="{ input: 'DD-MM-YYYY' }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <tr class="col-sm-12 p-0" style="display: table">
                      <td class="col-sm-6 py-0 pl-0">
                        <input
                          :value="inputValue.start"
                          v-on="inputEvents.start"
                          class="form-control"
                          placeholder="DD-MM-YYYY"
                        />
                        <p v-if="dateFromError" class="error-message">
                          Start Required
                        </p>
                      </td>
                      <td class="col-sm-6 py-0 pr-0">
                        <input
                          :value="inputValue.end"
                          v-on="inputEvents.end"
                          class="form-control"
                          placeholder="DD-MM-YYYY"
                        />
                        <p v-if="dateToError" class="error-message">
                          End Required
                        </p>
                      </td>
                    </tr>
                  </template>
                </datepicker>
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col md="6">
                <!-- <label for>Mobile Number Of Employees Enrolled</label> -->
                <!-- <v-text-field
                  name="Number"
                  placeholder="Number"
                  outlined
                  hide-details="auto"
                ></v-text-field>-->
                <div id="app">
                  <div class="csv-input-box">
                    <h2 class="text-capitalize csv-label">select CSV file</h2>
                    <input
                      type="file"
                      class="border-radius custom-file-input"
                      accept=".csv"
                      @change="uploadFile"
                    />
                  </div>
                </div>
                <span
                  >To download Template CSV
                  <a @click="downloadCsv()">Clik here</a>
                </span>
              </v-col>
              <v-col md="6">
                <label for>Amount</label>
                <div class="d-flex">
                  <v-text-field
                    name="Amount"
                    placeholder="Amount"
                    outlined
                    hide-details="auto"
                    class="border-r-l"
                    v-model="amount"
                    :rules="amountValueRules"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col md="6">
                <label for>Type of agreement *</label>
                <v-text-field
                  name="Type"
                  placeholder="Type"
                  outlined
                  hide-details="auto"
                  v-model="type_of_agreement"
                  :rules="typeOfAgreementRules"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="attach-loader">
                <label for>Attach Agreement *</label>
                <file-upload
                  :media="'image'"
                  label="Upload"
                  src
                  :role="'patient'"
                  :multiple="false"
                  :module="'coupon_code_test'"
                  :drop="true"
                  :uploadFileToServer="true"
                  :uploadedImg="uploadedImg"
                  @uploaded="fileUploaded"
                  @removeImage="deleteImg"
                ></file-upload>
                <p v-if="fileError" class="error-message">File Required</p>
              </v-col>
            </v-row>
          </v-form>
        </CCol>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" class="mr-3 fsddf" @click.stop="$emit('close')"
          >Cancel</v-btn
        >
        <v-btn color="success" :disabled="loading" @click="saveCampaign"
          >Generate</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import dayjs from "dayjs";
import FileUpload from "@/components/FileUpload.vue";
import Config from "@/config.js";
export default {
  props: ["createEnrolledOrganization"],
  components: {
    Datepicker,
    FileUpload,
  },
  data() {
    return {
      // ui
      loading: false,
      dateRange: {},
      //validation rules
      mobileRules: [
        (v) => !!v || "Mobile no is required",
        (v) =>
          (v && v.length <= 10) ||
          "Mobile Number should not be more than 10 digits",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      valueRules: [
        (v) => !!v || "Value is required",
        (v) => (v && v > 0) || "Value should be greater than zero",
      ],
      nameRules: [(v) => !!v || "Name is required"],
      campaignNameRules: [(v) => !!v || "Campaign Name is required"],
      amountValueRules: [
        (v) => !!v || "Discount Value is required",
        (v) => (v && v > 0) || "Discount Value should be greater than zero",
      ],
      applicableForRules: [(v) => !!v || "Applicable For is required"],
      typeOfAgreementRules: [(v) => !!v || "Type of agreement is required"],
      showApplicableToError: false,
      dateFromError: false,
      dateToError: false,
      fileError: false,
      valid: false,
      auxValidation: false,
      amount: 0,
      applicable_for_modules: [],
      organization: {
        name: "",
        contact: { name: "", mobile: "", email: "" },
      },
      campaignName: "",
      activation_date: "",
      expiry_date: "",
      type_of_agreement: "",
      uploadedImgFullUrl: [],
      uploadedImg: [],
      member_mobile_numbers_Uploaded_files: [],
      member_mobile_numbers_Uploaded_files_name: "",
    };
  },
  methods: {
    saveCampaign() {
      this.auxillaryValidations();
      if (this.$refs.createForm.validate() && this.auxValidation) {
        const formData = new FormData();

        for (const i of Object.keys(
          this.member_mobile_numbers_Uploaded_files
        )) {
          formData.append(
            "member_mobile_numbers_Uploaded_files",
            this.member_mobile_numbers_Uploaded_files[i]
          );
        }

        formData.set("campaign_name", this.campaignName);
        formData.set("terms_and_condition", this.type_of_agreement);
        formData.set("total_amount", this.amount);
        formData.set("organization_name", this.organization.name);
        formData.set(
          "organization_contact_person",
          this.organization.contact.name
        );
        formData.set(
          "organization_contact_number",
          this.organization.contact.mobile
        );
        formData.set(
          "organization_contact_email",
          this.organization.contact.email
        );
        formData.set("activation_date", this.activation_date);
        formData.set("expiry_date", this.expiry_date);
        formData.set("Uploaded_files", this.uploadedImgFullUrl);

        this.$http
          .post(`${Config.BASE_URL}api/v2/admin/campaign`, formData, {})
          .then(
            (response) => {
              this.loading = false;
              this.$emit("close");
            },
            (err) => {
              this.loading = false;
              console.log(err);
            }
          );
        this.loading = false;
      }
    },
    onDateChange(date) {
      this.activation_date = dayjs(date.start).format("YYYY-MM-DD");
      this.expiry_date = dayjs(date.end).format("YYYY-MM-DD");
    },
    auxillaryValidations() {
      this.auxValidation =
        (this.activation_date ? true : false) &&
        (this.expiry_date ? true : false) &&
        (this.uploadedImgFullUrl.length > 0 ? true : false) &&
        this.member_mobile_numbers_Uploaded_files;

      if (this.activation_date) {
        this.dateFromError = false;
      } else {
        this.dateFromError = true;
      }

      if (this.expiry_date) {
        this.dateToError = false;
      } else {
        this.dateToError = true;
      }

      if (this.uploadedImgFullUrl.length > 0) {
        this.fileError = false;
      } else {
        this.fileError = true;
      }
    },
    fileUploaded(files, uploaded, name) {
      this.loading = true;
      if (uploaded) {
        this.loading = false;
        this.uploadedImgFullUrl = files;
        this.uploadedImg = files.map((el) => {
          return el.split("/").pop();
        });
        this.fileError = false;
      }
    },

    deleteImg() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
      this.fileError = true;
    },

    uploadFile(e) {
      this.member_mobile_numbers_Uploaded_files = e.target.files;
    },

    downloadCsv() {
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(
        new Blob(["\ufeff", `first_name,last_name,mobile_no`])
      );
      downloadLink.download =
        "export_sample_organization_campaign_users_headers.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
  },
};
</script>

<style>
.error-message {
  color: red;
  font-size: 12px;
}
</style>